import React, { useState, useEffect } from "react";
import { NavLink as RouterLink, useNavigate } from "react-router-dom";
import PropTypes from "prop-types";
// import { getSVG } from "../../utils/getSvg";
import { GetScreenSize } from "../../utils/screenSize";
import { Box, Button, Collapse, ListItem, useTheme } from "@mui/material";
import layoutActions from "../../redux/actions/layout.actions";
import { connect } from "react-redux";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';

const NavItem = ({
  active,
  children,
  depth,
  icon,
  info,
  open: openProp,
  path,
  title,
  sideNavChange,
  setIsOpen,
  priority,
  isOpen,
  ...other
}) => {
  const screenSize = GetScreenSize()
  const [open, setOpen] = useState(false);
  const navigate = useNavigate();
  const theme = useTheme()
  useEffect(() => {
    if (priority === 'high')
      if (isOpen?.includes(title))
        setOpen(true)
      else
        setOpen(false)
  }, [isOpen])

  const handleToggle = (title) => {
    if (title === isOpen && priority === 'high'){
      setIsOpen('')
    }
    else if (priority === 'high'){
      setIsOpen(title);
    }
    else{
      setOpen(!open)
    }
  };

  let paddingLeft = 16;

  if (depth > 0) {
    paddingLeft = 32 + 8 * depth;
  }

  // Branch
  if (children) {
    return (
      <ListItem
        disableGutters
        sx={{
          display: "block",
          py: 0,
        }}
        {...other}
      >
        <Button
          endIcon={
            <ArrowDropDownIcon />
          }
          onClick={() => {
            handleToggle(title);
          }}
          startIcon={icon}
          sx={{
            color: priority === "high" ? "text.primary" : 'text.secondary',
            fontWeight: "700",
            justifyContent: "flex-start",
            pl: `${paddingLeft}px`,
            pr: "8px",
            py: "12px",
            textAlign: "left",
            textTransform: "none",
            width: "100%",
            cursor: 'pointer',
            ':hover': {
              backgroundColor: 'background.hover'
            },
            ...(active && {
              '&.MuiButtonBase-root': {
                backgroundColor: priority === "high" ? 'primary.main' : null,
              },
              color: priority === 'high' ? 'navItems.active.text' : "navItems.active.subText",
              backgroundColor: priority === "high" ? 'primary.main' : null,
              fontWeight: "fontWeightBold",
            }),
          }}
          variant="text"
        >
          <Box sx={{ flexGrow: 1, display: 'flex' }}>
            {title}
          </Box>

        </Button>
        <Collapse sx={{ maxWidth: '100%' }} in={Boolean(open)}>{children}</Collapse>
      </ListItem>
    );
  }

  return (
    <ListItem
      disableGutters
      sx={{
        display: "flex",
        py: 0,
      }}
      {...other}
    >
      <Button
        onClick={() => {
          navigate(path);
          if (priority === 'high')
            setIsOpen('')
          if (screenSize.dynamicWidth <= 666)
            sideNavChange(false)
        }}
        startIcon={icon}
        sx={{
          color: priority === "high" ? "text.primary" : 'text.third',
          fontWeight: "700",
          justifyContent: "flex-start",
          textAlign: "left",
          pl: `${paddingLeft}px`,
          pr: "8px",
          py: "12px",
          textTransform: "none",
          width: "100%",
          cursor: 'pointer',
          ':hover': {
            backgroundColor: 'background.hover'
          },
          ...(active && {
            '&.MuiButtonBase-root': {
              backgroundColor: priority === "high" ? 'primary.main' : null,
            },
            color: priority === 'high' ? 'navItems.active.text' : "navItems.active.subText",
            backgroundColor: priority === "high" ? 'primary.main' : null,
            fontWeight: "fontWeightBold",
          }),
        }}
        variant="text"
      >
        <Box sx={{ flexGrow: 1 }}>

          {title}

        </Box>

      </Button>
    </ListItem>
  );
};

NavItem.propTypes = {
  active: PropTypes.bool,
  children: PropTypes.node,
  depth: PropTypes.number.isRequired,
  icon: PropTypes.node,
  info: PropTypes.node,
  open: PropTypes.bool,
  path: PropTypes.string,
  title: PropTypes.string.isRequired,
};

NavItem.defaultProps = {
  active: false,
  open: false,
};
const mapStateToProps = (state) => ({
  isOpen: state.layout.sectionOpen
});

const mapDispatchToProps = (dispatch) => ({
  sideNavChange: (state) => dispatch(layoutActions.updateSideNav(state)),
  setIsOpen: (state) => dispatch(layoutActions.updateSideNavSection(state))
});

export default connect(mapStateToProps, mapDispatchToProps)(NavItem);
